import './audioPlayer.css';

const AudioPlayer = ({ url }) => {

    return (
        <div className="bg-[#2D4F71] ">
            <audio
                controls
                controlsList="nodownload"
                // autoPlay={true}
                className="w-full"
            >
                <source src={url}  type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
        </div>
    )
}

export default AudioPlayer;
